import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '@hemro/shared';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';


@NgModule({
    declarations: [
        LanguagesComponent,
    ],
    imports     : [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        TranslocoModule,
    ],
    exports     : [
        LanguagesComponent,
    ],
})
export class LanguagesModule
{
}
